export const getSetType = (activeTab) => {
  switch (activeTab) {
  case 'questionsets':
    return 'Question';
  case 'flashcardsets':
    return 'Flash Card';
  case 'resourcesets':
    return 'Resource';
  default:
    return '';
  }
};